<template>
<div>
  <!-- <OverlayLoading :loading="loading" /> -->
  <v-row class="mt-3 px-5">
    <v-col cols="12" sm="6" md="3" lg="3" class="pt-0 pb-0 mt-6">
      <v-autocomplete
        v-model="keywordSmall"
        :items="itemSmall"
        item-text="positionName"
        item-value="positionName"
        outlined
        label="ตำแหน่งงาน"
        placeholder="ค้นหา ตำแหน่งงาน"
        class="mt-2"
        dense
        @keyup="getSelectCompany($event.target.value, 'ตำแหน่งงาน')"
        @change="searchFilterData()"
        clearable
      >
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pt-0 pb-0 mt-6">
      <v-autocomplete
        v-model="keywordPositionLevel"
        :items="itemPositionLevel"
        item-text="positionLvName"
        item-value="_id"
        outlined
        label="ระดับตำแหน่งพนักงาน"
        placeholder="ค้นหา ระดับตำแหน่ง"
        class="mt-2"
        dense
        @keyup="getSelectCompany($event.target.value, 'ระดับตำแหน่ง')"
        @change="searchFilterData()"
        clearable
      >
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pt-0 pb-0 mt-6">
      <v-autocomplete
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        item-text="companyFullNameTh"
        item-value="_id"
        outlined
        label="ชื่อบริษัท"
        placeholder="ค้นหา ชื่อบริษัท"
        class="mt-2"
        dense
        @keyup="getSelectCompany($event.target.value, 'บริษัท')"
        @change="searchFilterData()"
        clearable
      >
      <!-- <template #selection="{ item }">
          <v-chip color="#0370B7 !important" class="mt-0" small>
            <span class="filter-chip_department">{{item.companyName}}</span>
          </v-chip>
        </template> -->
      </v-autocomplete>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="2" lg="2" class="pt-0 pb-0 mt-6">
      <v-autocomplete
        v-model="keywordGroupCompanyName"
        :items="itemGroupCompanyName"
        item-text="groupCompanyName"
        item-value="groupCompanyId"
        outlined
        label="ชื่อเครือ"
        placeholder="ค้นหา ชื่อเครือ"
        class="mt-2"
        dense
        clearable
        @change="searchFilterData()"
      >
      </v-autocomplete>
    </v-col> -->
    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0 pb-lg-0 pb-sm-5  d-flex align-center justify-end mt-4 ml-0">
      <v-btn
            depressed
            style="border-radius: 6px;"
            dark
            class="button-color ra-text-in-button-employee"
            @click="gotocreate()"
          >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
            เพิ่มตำแหน่ง
          </v-btn>
      <!-- <v-row justify="end" class="mr-16">
        <v-col cols="2" sm="2" md="2" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1">
          <v-btn
            outlined
            class=""
            color="#3776E9"
            @click="openDialogUpload()"
          >
            <v-icon left dark color="#3776E9" size="14px">fa-cloud-upload-alt</v-icon>
            <span class="ra-text-in-button">
              อัปโหลดไฟล์
            </span>
          </v-btn>
        </v-col>
        <v-col cols="2" sm="2" md="2" lg="2" class="pt-0 pb-0 d-flex align-center justify-start mt-1 mr-12">
          <v-btn
            outlined
            class="ra-button-postition"
            dark
            @click="gotocreate()"
            >
            <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
            <span class="ra-text-in-button-postition">
              เพิ่มตำแหน่ง
            </span>
          </v-btn>
        </v-col>
      </v-row> -->
    </v-col>
    <!-- <v-col cols="12" sm="12" md="6" lg="4" class="pt-0 pb-0 d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
        <v-btn class="mr-5" style="min-height: 38px;" color="success" dark @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn class="" style="min-height: 38px;" outlined color="success" dark @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col> -->
  </v-row>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectPositionNew
} from '@/API/API'
// import DialogUploadFile from '../_dialog/dialogUploadFile.vue'

export default {
  name: 'filter-workgroup',
  components: {
    // OverlayLoading,
    // DialogUploadFile
  },
  data () {
    return {
      tokenUser: '',
      keywordSmall: '',
      keywordLineWorkName: '',
      keywordCompanyName: [],
      keywordPositionLevel: [],
      keywordGroupCompanyName: '',
      filterData: {
        companyShortName: [],
        managementName: '',
        managementHeader: '',
        userName: '',
        userPosition: ''
      },
      itemSmall: [],
      itemLineWorkName: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemPositionLevel: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  watch: {
    keywordSmall: function (val) {
      if (val && val.length) {
        this.filterData.companyShortName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordLineWorkName: function (val) {
      if (val && val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  mounted () {
    // EventBus.$on('getFilterPosition', this.getSelectData)
    // EventBus.$on('selectPosition', this.getSelectValue)
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.getSelectCompany()
  },
  methods: {
    // ตัวเลือกค้นหาหัวตาราง
    async getSelectCompany (value, key) {
      this.loading = true
      var datafilterall = ''
      const token = this.tokenUser
      if (key === 'บริษัท') {
        const obj = {
          positionName: '',
          companyName: value,
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      } else if (key === 'ตำแหน่งงาน') {
        const obj = {
          positionName: value,
          companyName: '',
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      } else if (key === 'ระดับตำแหน่ง') {
        const obj = {
          positionName: '',
          companyName: '',
          companyId: '',
          positionLevelName: value,
          positionLevel: ''
        }
        datafilterall = obj
      } else {
        const obj = {
          positionName: '',
          companyName: '',
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectPositionNew(datafilterall, token)
        if (res.success) {
          if (key === 'บริษัท') {
            this.itemCompanyName = res.company // บริษัท
          } else if (key === 'ตำแหน่งงาน') {
            this.itemSmall = res.position // ตำแหน่งงาน
          } else if (key === 'ระดับตำแหน่ง') {
            this.itemPositionLevel = res.positionLevelResult // ระดับตำแหน่ง
          } else {
            this.itemCompanyName = res.company // บริษัท
            this.itemSmall = res.position // ตำแหน่งงาน
            this.itemPositionLevel = res.positionLevelResult // ระดับตำแหน่ง
          }
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // getSelectValue (data) {
    //   // console.log('filter select position', data)
    //   this.itemSmall = data.position // ตำแหน่งงาน
    //   this.itemCompanyName = data.company // บริษัท
    //   this.itemGroupCompanyName = data.groupCompany // ชื่อเครือ
    //   this.itemPositionLevel = data.positionLevel // ระดับตำแหน่งพนักงาน
    // },
    // getSelectData (data) {
    //   this.itemSmall = data.companyShortName // ตำแหน่งงาน
    //   this.itemCompanyName = data.companyName // บริษัท
    //   this.itemGroupCompanyName = data.groupCompanyName // ชื่อเครือ
    // },
    resetFilterData () {
      this.keywordSmall = ''
      this.keywordLineWorkName = ''
      this.keywordCompanyName = []
      this.keywordPositionLevel = []
      this.keywordGroupCompanyName = []
      this.filterData = {
        positionName: '',
        companyName: [],
        positionLevelId: [],
        groupCompany: [],
        limit: 15,
        page: 1
      }
      EventBus.$emit('filterPosition', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        positionName: this.keywordSmall,
        companyName: this.keywordCompanyName,
        groupCompany: this.keywordGroupCompanyName,
        positionLevelId: this.keywordPositionLevel,
        limit: 15,
        page: 1
      }
      EventBus.$emit('filterPosition', this.filterData)
    },
    gotocreate () {
      this.$router.push('manageposition/create')
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  /* font-weight: normal; */
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-button-postition {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button-postition {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
</style>
